const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
export function naturalCompare(x, y) {
    return collator.compare(x, y);
}
//# sourceMappingURL=naturalCompare.js.map